import { ContextCancelation, Plugin, Context } from '@segment/analytics-next';

const handleEvent = (ctx: Context) => {
  if (!window?.OptanonActiveGroups?.includes('C0004')) {
    ctx.cancel(
      new ContextCancelation({
        reason: 'AJS Disabled due being opted out',
        retry: false,
      }),
    );
  }

  return ctx;
};

/**
 *
 */
const blockOptedOutUsers: Plugin = {
  name: 'blockOptedOutUsers',
  type: 'before',
  version: '1.0.0',

  isLoaded: () => true,
  load: () => Promise.resolve(),

  track: handleEvent,
  page: handleEvent,
  identify: handleEvent,
  alias: handleEvent,
  group: handleEvent,
  screen: handleEvent,
};

export default blockOptedOutUsers;
